<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Impuesto {{ form.descripcion }}</h3>
      </div>
      <div class="layout__controls">
        <button v-show="(permiteEditarImpuesto || permiteEliminarImpuesto)" @click="consultarTarifas" class="btn-info btn--bigger" type="button"><i class="fa fa-search"></i> <span>Buscar</span></button>
        <modal width="80%" height="auto" name="listaImpuestos" scrollable>
          <lista-impuestos @selected="selectedTarifa" :createButton="false" :editButton="false" :deleteButton="false"></lista-impuestos>
        </modal>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <h5>Información del impuesto</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <div :class="{'select2--disabled' : estado !== 'N'}"
                  class="form-field select2">
                  <div class="select2-field">
                    <v-select v-model="selectedImpuesto" label="nombre" id="impuesto" placeholder="Seleccione..." :options="impuestos"></v-select>
                    <label for="impuesto">Impuesto</label>
                    <span v-if="errores.id_impuesto" class="helper-text text-danger" slot="helper">
                      {{ errores.id_impuesto[0] }}
                    </span>
                  </div>
                </div>
                <div class="form-field">
                  <input-field :readonly="estado !== 'N'" v-model="form.descripcion" id="descripcion" placeholder="###">
                    <span>Descripción</span>
                    <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
                      {{ errores.descripcion[0] }}
                    </span>
                  </input-field>
                </div>
                <div class="form-field">
                  <input-field v-model="form.porcentaje" id="porcentaje" placeholder="##.## %" vMoney :format="porcentaje">
                    <span>Porcentaje %</span>
                    <span v-if="errores.porcentaje" class="helper-text text-danger" slot="helper">
                      {{ errores.porcentaje[0] }}
                    </span>
                  </input-field>
                </div>
                <div class="form-field">
                  <input-field :readonly="!esIce" v-model="form.numero_unidades" id="numero_unidades" placeholder="##.##"
                    vMoney :format="decimal">
                    <span># Unidades</span>
                    <span v-if="errores.numero_unidades" class="helper-text text-danger" slot="helper">
                      {{ errores.numero_unidades[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <input-field :readonly="estado !== 'N'" v-model="form.id_tarifa" id="id_tarifa" placeholder="###">
                    <span>Cod. Tarifa</span>
                    <span v-if="errores.id_tarifa" class="helper-text text-danger" slot="helper">
                      {{ errores.id_tarifa[0] }}
                    </span>
                  </input-field>
                </div>
                <div class="form-field">
                  <input-field :readonly="!esIce" vMoney :format="money" v-model="form.tarifa_especifica" id="tarifa_especifica"
                    placeholder="$ ##.##">
                    <span>Tarifa específica</span>
                    <span v-if="errores.tarifa_especifica" class="helper-text text-danger" slot="helper">
                      {{ errores.tarifa_especifica[0] }}
                    </span>
                  </input-field>
                </div>
                <div class="form-field">
                  <input-field :readonly="!esIce" vMoney :format="money" v-model="form.tarifa_ed_valorem" id="tarifa_ed_valorem"
                    placeholder="$ ##.##">
                    <span>Tarifa ed valorem</span>
                    <span v-if="errores.tarifa_ed_valorem" class="helper-text text-danger" slot="helper">
                      {{ errores.tarifa_ed_valorem[0] }}
                    </span>
                  </input-field>
                </div>
                <div v-show="selectedImpuesto !== null && selectedImpuesto.es_retenible === 'S'" class="form-field">
                  <p>
                    <label for="aplicaRetencion">
                      <input type="checkbox" id="aplicaRetencion" v-model="form.aplica_retencion"> <span>Aplica retención</span>
                    </label>
                  </p>
                </div>
              </div>
              <div class="col-xs-12 col-md-6" v-show="form.id_impuesto == '1'">
                <div class="form-field">
                  <div class="datepicker-field">
                    <date-picker
                      type="date"
                      format="dd-MM-yyyy"
                      id="fecha"
                      v-model="form.fecha_habilitacion"
                      lang="es"
                      :disabled="estado!='N'"
                    ></date-picker>
                    <label>Fecha desde que aplica</label>
                    <span
                      v-if="errores.fecha_habilitacion"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.fecha_habilitacion[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>  
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button v-show="(permiteCrearImpuesto && estado === 'N') || (permiteEditarImpuesto && estado !== 'N')" @click="guardarTarifa" class="btn-success" type="button"><i class="fa fa-save"></i> <span>Guardar</span></button>
            <button v-show="permiteCrearImpuesto" @click="nuevoImpuesto" class="btn-light btn--text" type="button"><i class="fa fa-plus"></i> <span>Nuevo</span></button>
            <button v-show="estado === 'A' && permiteEliminarImpuesto" @click="eliminarImpuesto" type="button" class="btn-danger btn--text"><i class="fa fa-ban"></i> <span>Eliminar</span></button>
            <button v-show="estado === 'I' && permiteEliminarImpuesto" @click="eliminarImpuesto" type="button" class="btn-secondary btn--text"><i class="fa fa-power-off"></i> <span>Re-activar</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props : {
    permiteCrearImpuesto : {
      type : Boolean,
      default : true,
      required : true
    },
    permiteEditarImpuesto : {
      type : Boolean,
      default : true,
      required : true
    },
    permiteEliminarImpuesto : {
      type : Boolean,
      default : true,
      required : true
    }
  },
  data : function () {
    return {
      form : {
        id_impuesto : '',
        id_tarifa : '',
        descripcion : '', 
        porcentaje : 0,
        tarifa_especifica : 0,
        numero_unidades : 0,
        tarifa_ed_valorem : 0,
        fecha_habilitacion: '',
        _method : undefined,
        aplica_retencion : false
      },
      estado : 'N',
      selectedImpuesto : null,
      impuestos : [],
      errores : {
        id_impuesto : undefined,
        id_tarifa : undefined,
        descripcion : undefined, 
        porcentaje : undefined,
        tarifa_especifica : undefined,
        numero_unidades : undefined,
        tarifa_ed_valorem : undefined,
        fecha_habilitacion : undefined
      },
      url : url,
      porcentaje : porcentaje,
      money : money,
      decimal : decimal,
      id : ''
    };
  },
  methods : {
    cargarDatosFormulario : function () {
      let that = this;
      axios.get(url + '/impuestos/datos').then(function (response) {
        that.impuestos = response.data.impuestos;
      });
    },
    consultarTarifas : function () {
      this.$modal.show('listaImpuestos');
    },
    selectedTarifa : function (tarifa) {
      this.limpiarFormulario();
      this.limpiarErrores();
      this.id = tarifa.id;
      this.form.id_tarifa = tarifa.id_tarifa;
      this.form.descripcion = tarifa.descripcion;
      this.form.porcentaje = tarifa.porcentaje;
      this.form.tarifa_especifica = tarifa.tarifa_especifica;
      this.form.numero_unidades = tarifa.numero_unidades;
      this.form.tarifa_ed_valorem = tarifa.porcentaje_ed_valorem;      
      this.form.aplica_retencion = tarifa.aplica_retencion === 'S';
      this.form.fecha_habilitacion = tarifa.fecha_habilitacion;
      for (let i = 0; i < this.impuestos.length; i++) {
        if (this.impuestos[i].id_impuesto === tarifa.id_impuesto) {
          this.selectedImpuesto = this.impuestos[i];
          break;
        }
      }
      this.estado = tarifa.estado;
      this.$modal.hide('listaImpuestos');
    },
    limpiarFormulario : function () {
      this.form = {
        id_impuesto : '',
        id_tarifa : '',
        descripcion : '', 
        porcentaje : 0,
        tarifa_especifica : 0,
        numero_unidades : 0,
        tarifa_ed_valorem : 0,
        aplica_retencion : false,
        fecha_habilitacion : ''
      };
      this.selectedImpuesto = null;
      this.id = '';
    },
    limpiarErrores : function () {
      this.errores = {
        id_impuesto : undefined,
        id_tarifa : undefined,
        descripcion : undefined, 
        porcentaje : undefined,
        tarifa_especifica : undefined,
        numero_unidades : undefined,
        tarifa_ed_valorem : undefined,
        fecha_habilitacion : undefined
      };
    },
    guardarTarifa : function () {
      this.limpiarErrores();
      let that = this;
      let urlRequest = url + '/impuestos';
      if (this.estado !== 'N') {
        urlRequest += '/' + this.id;
        this.form._method = 'PUT';
      }
      else 
        this.form._method = undefined;
      axios.post(urlRequest, this.form).then(function (response) {
        that.id = response.data.id;
        that.estado = response.data.estado;
        swal('La tarifa de impuesto fue almacenada corréctamente.', 'Realizado', 'success');
      }).catch(function (error) {
        if (error !== null && error !== undefined) {
          let response = error.response;
          if (response !== null && response !== undefined) {
            let status = response.status;
            if (status === 422) {
              that.errores = response.data.errors;
              swal('El formulario posee errores.', 'Mensaje', 'warning');
            }
            else 
              swal('Hubo un error, intente nuevamente.', 'Error', 'error');
          }
        }
      });
    },
    nuevoImpuesto : function () {
      let that = this;
      swal({
        title: '¿Desea crear un nuevo impuesto?',
        text: "El formulario será reiniciado.",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText : 'Crear nuevo',
        cancelButtonText : 'Cancelar'
      }).then((result) => {
        if (result.value) {
          that.limpiarFormulario();
          that.limpiarErrores();
          that.estado = 'N';
        }
      });
    },
    eliminarImpuesto : function () {
      let that = this;
      swal({
        title: '¿Desea ' + (this.estado === 'A'?'eliminar':'re-activar') + ' este impuesto?',
        text: "El impuesto será " + (this.estado === 'A'?'eliminado':'re-activado') + ".",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText : (this.estado === 'A'?'Eliminar':'Re-activar'),
        cancelButtonText : 'Cancelar'
      }).then((result) => {
        if (result.value) {
          axios.post(that.url + '/impuestos/' + that.id, {
            _method : 'DELETE',
            id_impuesto : that.form.id_impuesto
          }).then(function (response) {
            that.estado = response.data.estado === 'A'?'I':'A';
            swal('El impuesto ha sido ' + (that.estado === 'I'?'eliminado':'re-activado') + '.', 'Realizado', 'success');
          });
        }
      });
    }
  },
  mounted : function () {
    this.cargarDatosFormulario();
  },
  watch : {
    selectedImpuesto : function (value) {
      if (value !== null && value !== undefined) {
        this.form.id_impuesto = value.id_impuesto;
        if (value.es_retenible !== 'S')
          this.form.aplica_retencion = false;
      }
      else {
        this.form.id_impuesto = '';
        this.form.aplica_retencion = false;
      }
    },
    'form.fecha_habilitacion': function(value){
      if(value != null && value != undefined){
        if(value.length == 10){
          let date = new Date(value);
          if(date == "Invalid Date"){
            swal("Error", "La fecha es incorrecta", "error");
            this.form.fecha_habilitacion = null;
          }
        }
      }
    }
  },
  computed : {
    esIce : function () {
      if (this.selectedImpuesto !== null && this.selectedImpuesto.es_especial === 'S')
        return true;
      return false;
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/impuestos/Impuesto.vue